import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIDescriptionWrapper } from './components/AIDescriptionWrapper';

async function LoadAIDescriptionStep(): Promise<typeof AIDescriptionWrapper> {
	return (
		await import(
			/* webpackChunkName: "pages/start-a-petition-steps-ai-description" */ './components/AIDescriptionWrapper'
		)
	).AIDescriptionWrapper;
}

export function AIDescriptionLoader(): JSX.Element {
	const loadComponent = useCallback(LoadAIDescriptionStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadAIDescriptionStep = LoadAIDescriptionStep;
